import React from 'react';
import { connect } from 'react-redux';
import ProviderEmploymentDashboardPage from './ProviderEmploymentDashboardPage';
import StaffDashboardPage from './StaffDashboardPage';

const Dashboard = ({ currentAgent }) => {
  switch (currentAgent.currentEmployment.type) {
    case 'ProviderEmployment':
      return (
        <ProviderEmploymentDashboardPage providerEmploymentId={currentAgent.currentEmployment.id} />
      );
    case 'StaffEmployment':
      return <StaffDashboardPage staffEmployment={currentAgent.currentEmployment} />;
    default:
      return null;
  }
};

Dashboard.displayName = 'Dashboard';

function mapStateToProps(state) {
  return {
    currentAgent: state.currentAgent,
  };
}

export default connect(mapStateToProps)(Dashboard);
